import { ColumnDef } from "@tanstack/react-table";
import { enumToStringConverter } from "../../../../../helpers/appHelpers";

// Type definitions
interface HolidayRow {
	id: number;
	name: string;
	date: string;
	code: string;
	description: string;
	type: string;
	createdAt?: string;
	modifiedAt?: string;
}

// Helper function for date formatting
function formatDate(inputDate: string): string {
	const date = new Date(inputDate);

	const fullMonths = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];

	const month = fullMonths[date.getMonth()];
	const day = date.getDate();

	// Determine the suffix based on the last digit of the day
	const lastDigit = day % 10;
	let suffix = "th";
	if (lastDigit === 1 && day !== 11) {
		suffix = "st";
	} else if (lastDigit === 2 && day !== 12) {
		suffix = "nd";
	} else if (lastDigit === 3 && day !== 13) {
		suffix = "rd";
	}

	const formattedDate = `${day}${suffix} ${month}`;

	return formattedDate;
}

// ========== Holidays Columns ==========
export const holidaysColumns: ColumnDef<HolidayRow>[] = [
	{
		id: "name",
		accessorKey: "name",
		header: "Name",
		size: 200,
	},
	{
		id: "date",
		accessorKey: "date",
		header: "Date",
		size: 200,
		cell: ({ row }) => formatDate(row.original.date),
	},
	{
		id: "code",
		accessorKey: "code",
		header: "Code",
		size: 180,
	},
	{
		id: "description",
		accessorKey: "description",
		header: "Description",
		size: 350,
	},
	{
		id: "type",
		accessorKey: "type",
		header: "Type",
		size: 200,
		cell: ({ row }) => enumToStringConverter(row.original.type),
	},
];

export const holidaysColumnVisibility: Record<string, boolean> = {
	name: true,
	date: true,
	code: true,
	description: true,
	type: true,
};
